import React from 'react';
import PropTypes from 'prop-types';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { useRecoilValue } from 'recoil';
import { isDevAuthBypass } from '../../config/config';
import { devBypassEmailState } from '../../state/apiData';

// Wrappers dev-aware autour des templates MSAL.
// En dev avec une connexion simulée active (devBypassEmailState), on court-circuite
// MSAL. Sinon (prod, ou dev sans bypass actif), comportement MSAL inchangé.

export const LoggedIn = ({ children }) => {
  const devEmail = useRecoilValue(devBypassEmailState);
  if (isDevAuthBypass && devEmail) {
    return <>{children}</>;
  }
  return <AuthenticatedTemplate>{children}</AuthenticatedTemplate>;
};

export const LoggedOut = ({ children }) => {
  const devEmail = useRecoilValue(devBypassEmailState);
  if (isDevAuthBypass && devEmail) {
    return null;
  }
  return <UnauthenticatedTemplate>{children}</UnauthenticatedTemplate>;
};

LoggedIn.propTypes = {
  children: PropTypes.node.isRequired,
};

LoggedOut.propTypes = {
  children: PropTypes.node.isRequired,
};
